
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref844"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref844"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $6XCpN = parcelRequire("6XCpN");

var $j5aU9 = parcelRequire("j5aU9");
/* Locomotive scroll instance */ const $76d9b62870027d53$var$locomotiveScroll = new (0, $j5aU9.default)();
//Initialize
const $76d9b62870027d53$var$second_content = $(".second_content");
const $76d9b62870027d53$var$about_img = $(".about_img");
const $76d9b62870027d53$var$caption = $(".main_flex h1");
const $76d9b62870027d53$var$second_trigger = $(".flex_box .second_flex");
const $76d9b62870027d53$var$sus_1 = $(".contract1 h4");
const $76d9b62870027d53$var$sus_2 = $(".contract1 p");
const $76d9b62870027d53$var$sus_image = $(".contract2");
const $76d9b62870027d53$var$about_header = $(".about h5");
const $76d9b62870027d53$var$about_header2 = $(".about h1");
const $76d9b62870027d53$var$about_body = $(".about p");
(0, $4AGbv.gsap).set([
    $76d9b62870027d53$var$sus_1,
    $76d9b62870027d53$var$sus_2,
    $76d9b62870027d53$var$sus_image
], {
    alpha: 0,
    y: 40
});
(0, $4AGbv.gsap).set([
    $76d9b62870027d53$var$about_header,
    $76d9b62870027d53$var$about_header2,
    $76d9b62870027d53$var$about_body,
    $76d9b62870027d53$var$about_img
], {
    alpha: 0,
    y: 40
});
$(window).on("load", function() {
    (0, $4AGbv.gsap).to([
        $76d9b62870027d53$var$about_header,
        $76d9b62870027d53$var$about_header2,
        $76d9b62870027d53$var$about_body,
        $76d9b62870027d53$var$about_img
    ], {
        alpha: 1,
        stagger: .1,
        y: 0,
        duration: 1
    });
});
$(window).scroll(function() {
    var scrollTop = $(this).scrollTop();
    if (scrollTop > $76d9b62870027d53$var$about_img.offset().top) $76d9b62870027d53$var$second_content.css({
        opacity: 1,
        transform: "translateY(0)"
    });
    if (scrollTop > $76d9b62870027d53$var$about_img.offset().top + 200) $76d9b62870027d53$var$caption.css({
        opacity: 1,
        transform: "translateY(0)"
    });
    if (scrollTop > $76d9b62870027d53$var$second_trigger.offset().top - 200) (0, $4AGbv.gsap).to([
        $76d9b62870027d53$var$sus_1,
        $76d9b62870027d53$var$sus_2,
        $76d9b62870027d53$var$sus_image
    ], {
        alpha: 1,
        y: 0,
        stagger: .2
    });
});
(0, $6XCpN.test)();


//# sourceMappingURL=about.529c842f.js.map
